
import { defineComponent, computed, ref } from 'vue'

export default defineComponent({
    props:{
        avatars: {
            type: Object,
            required: false,
            default: null,
        },
        bg: {
            type: Object,
                required: false,
                default: () => ({
                primary: null,
                secondary: null
            })
        },
        title: {
            type: String,
            required: true,
            default: ''
        }
    },
    setup(props) {

        const REPO = ref(process.env.VUE_APP_REPO);

        const backgroundGradient = computed(() => {
            // Validamos si existe props.bg y sus valores
            if (
                props.bg &&
                props.bg.primary &&
                props.bg.secondary
            ) {
                return `linear-gradient(to top, rgb(${props.bg.secondary}), rgb(${props.bg.secondary}))`;
            }

            // Si no viene, retornamos un color por defecto o vacío
            return "transparent"; 
        })
        
        return {
            REPO,
            backgroundGradient
        }
    },
})
